
import styled from 'styled-components';

export const Container = styled.div`

    margin: auto;
    width: 80%;

    
    .filter {
        margin-bottom: 3rem;
        display: flex;

        > div {
            width: 30rem;
            padding: 0;
            margin: 0;
        }
    }


    table {
        width: 100%;
        border-collapse: collapse;

        thead{
            font-family: Poppins;
            font-style: normal;
            font-weight: 600;
            font-size: 23px;
            line-height: 4rem;
            color: #3a3b3c;
        }

        tbody{
            box-shadow: 0 0 0 1px #dadadd;
            border-radius: 15px;

            td{
                label{
                    line-height: 4rem;
                    margin: 2rem;

                    font-family: Poppins;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 18px;
                    line-height: 4rem;
                    color: #3a3b3c;

                }
                
                border-bottom: 1px solid #dadadd;
            }
            

            tr:last-child{
                td{
                border-bottom: none;
            }
            }
        }

    }

    

    @media screen and (max-width: 576px){
        width: 100%;
        padding: .5rem;
    }
`;